import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 18px;
  h1{ margin:0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p{ margin: 0; }
`;

export const HeaderImage = styled.div`
  border-radius: 12px; overflow: hidden; background: ${({ theme }) => theme.colors.gray[100]}; min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto; padding: 0 16px;
`;

export const JobTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  overflow: hidden;

  th, td {
    padding: 14px 16px;
    text-align: left;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};
  }

  th {
    background: ${({ theme }) => theme.colors.green[50]};
    color: ${({ theme }) => theme.colors.green[800]};
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  tbody tr {
    cursor: pointer;
    transition: background 0.15s ease;
    &:hover {
      background: ${({ theme }) => theme.colors.gray[50]};
    }
    &:last-child td {
      border-bottom: none;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileJobList = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileJobCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.md};
  }

  h3 {
    margin: 0 0 8px;
    color: ${({ theme }) => theme.colors.green[700]};
    font-size: 1.1rem;
  }
`;

export const MobileJobMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.gray[600]};
`;

export const Badge = styled.span`
  display: inline-block;
  background: ${({ $variant, theme }) =>
    $variant === 'orange' ? theme.colors.orange[50] :
    $variant === 'red' ? '#fef2f2' :
    theme.colors.green[50]};
  color: ${({ $variant, theme }) =>
    $variant === 'orange' ? theme.colors.orange[700] :
    $variant === 'red' ? '#b91c1c' :
    theme.colors.green[700]};
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Modal = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 0;

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.green[700]};
    font-size: 1.4rem;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray[500]};
  padding: 4px;
  line-height: 1;
  &:hover { color: ${({ theme }) => theme.colors.gray[800]}; }
`;

export const ModalBody = styled.div`
  padding: 20px 24px 24px;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
`;

export const DetailList = styled.ul`
  margin: 0 0 16px;
  padding-left: 20px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.gray[700]};
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.gray[200]};
  margin: 20px 0;
`;

export const FormGroup = styled.div`
  margin-bottom: 14px;

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.gray[700]};
  }

  input, textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.colors.gray[300]};
    border-radius: 8px;
    font-size: 0.95rem;
    font-family: inherit;
    transition: border-color 0.15s;
    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.green[400]};
    }
  }

  textarea {
    min-height: 100px;
    resize: vertical;
  }

  input[type="file"] {
    border: none;
    padding: 0;
  }
`;

export const ApplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.green[600]};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;

  &:hover { background: ${({ theme }) => theme.colors.green[700]}; }
  &:disabled { opacity: 0.6; cursor: default; }
`;

export const SuccessMessage = styled.div`
  background: ${({ theme }) => theme.colors.green[50]};
  color: ${({ theme }) => theme.colors.green[800]};
  border: 1px solid ${({ theme }) => theme.colors.green[200]};
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5;

  strong {
    display: block;
    font-size: 1.1rem;
    margin-bottom: 6px;
  }
`;

export const ErrorText = styled.div`
  color: #dc2626;
  font-size: 0.85rem;
  margin-top: 4px;
`;
